import {
    CreateTradingViewTablePayload,
    CreateTablePayload,
    CreateTableByNlpPayload,
} from '@thinkalpha/platform-ws-client/contracts/table.js';
import type {
    TableCreationResultWithColumns,
    NlpTableCreationResult,
} from '@thinkalpha/platform-ws-client/contracts/table.js';
import type { ProxyClient } from '@thinkalpha/table-client';
import type { AxiosRequestConfig } from 'axios';
import { useMemo } from 'react';
import { createInstance } from 'src/api';
import { useContainer } from 'src/features/ioc';

const api = createInstance({}, { useLegacySerialization: false });

export const usePureProxyClient = (): ProxyClient => {
    const container = useContainer();
    return useMemo(() => container.get('ProxyClientService').client, [container]);
};

export const createTable = async (
    payload: CreateTablePayload,
    config?: AxiosRequestConfig,
): Promise<TableCreationResultWithColumns> => {
    const encoded = CreateTablePayload.encode(payload);
    const res = await api.post<TableCreationResultWithColumns>(`/tables`, encoded, config);
    return res.data;
};

export const createTableFromNLP = async (
    payload: CreateTableByNlpPayload,
    config?: AxiosRequestConfig,
): Promise<NlpTableCreationResult> => {
    const encoded = CreateTableByNlpPayload.encode(payload);
    const res = await api.post<NlpTableCreationResult>(`/tables/by-nlp`, encoded, config);
    return res.data;
};

export const createTradingViewTable = async (
    payload: CreateTradingViewTablePayload,
    config?: AxiosRequestConfig,
): Promise<TableCreationResultWithColumns> => {
    const encoded = CreateTradingViewTablePayload.encode(payload);
    const res = await api.post<TableCreationResultWithColumns>(`/tables/trading-view`, encoded, config);
    return res.data;
};
